<script setup lang="ts">
import cover from "@brand-cover"

interface GuestHeroImageProps {
  isLoading?: boolean
  coverImage?: string
}

withDefaults(defineProps<GuestHeroImageProps>(), {
  isLoading: false,
  coverImage: "",
})
</script>

<template>
  <div class="relative hidden h-full min-h-120 w-full overflow-hidden rounded-r-xl md:block">
    <img v-if="!isLoading && coverImage" :src="coverImage" class="absolute inset-0 size-full object-cover object-center">
    <img v-else :src="cover" class="absolute inset-0 size-full object-cover object-center">
  </div>
</template>
